import { CVStepPreferencesSchema } from 'schemas/cv-steps'
import { z } from 'zod'

const CVStepPreferencesValidator = CVStepPreferencesSchema.extend({
  expectedSalaryEuros: z.number().min(100).max(1000000)
}).passthrough()

export type ICVStepPreferencesValidator = z.infer<
  typeof CVStepPreferencesValidator
>

export default CVStepPreferencesValidator
